(function () {
  'use strict';

  function decodePreviewParam(str) {
    var b64 = str.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(decodeURIComponent(escape(atob(b64))));
  }

  function cm(val) { return (+val).toFixed(1) + ' cm'; }

  function render(payload) {
    var titleEl  = document.getElementById('ppb-preview-title');
    var renderEl = document.getElementById('ppb-preview-render');
    var metaEl   = document.getElementById('ppb-preview-meta');

    /* titel wordt door Liquid ingevuld — niet overschrijven */

    /* ── SVG ── */
    if (renderEl) {
      var W = payload.w;
      var H = payload.h;
      /* Tot okt 2026 kreeg elk linnen de grijze kleur van Linnen 1 mee;
         oudere links van Linnen 2 tonen zo toch het beige */
      var fill = payload.fill;
      if (payload.color === 'Linnen 2' && fill === '#cfcec4') fill = '#e8e0c7';
      var rects = '';
      (payload.o || []).forEach(function (r) {
        rects += '<rect x="' + r.x + '" y="' + r.y + '"' +
                 ' width="' + r.w + '" height="' + r.h + '"' +
                 ' fill="white" stroke="rgba(0,0,0,0.18)" stroke-width="0.3"/>';
      });
      renderEl.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg"' +
        ' viewBox="0 0 ' + W + ' ' + H + '"' +
        ' style="width:100%;height:auto;display:block;">' +
        '<rect width="' + W + '" height="' + H + '" fill="' + fill + '"/>' +
        rects +
        '<rect width="' + W + '" height="' + H + '" fill="none" stroke="rgba(0,0,0,0.2)" stroke-width="0.4"/>' +
        '</svg>';
    }

    /* ── Details tabel ── */
    if (!metaEl) return;

    var rows = '';

    function row(label, value) {
      rows += '<tr><td>' + label + '</td><td>' + value + '</td></tr>';
    }

    function groupHeader(label) {
      rows += '<tr class="ppb-opening-group"><td colspan="2">' + label + '</td></tr>';
    }

    row('Formaat', payload.label || '—');
    row('Kleur', payload.color || '—');
    row('Aantal openingen', String((payload.o || []).length));

    (payload.o || []).forEach(function (o, i) {
      var marginLeft   = o.x;
      var marginTop    = o.y;
      var marginRight  = payload.w - o.x - o.w;
      var marginBottom = payload.h - o.y - o.h;

      if (payload.o.length > 1) groupHeader('Opening ' + (i + 1));

      row('Binnenmaat', cm(o.w) + ' × ' + cm(o.h));
      row('Marge links',  cm(marginLeft));
      row('Marge rechts', cm(marginRight));
      row('Marge boven',  cm(marginTop));
      row('Marge onder',  cm(marginBottom));
    });

    metaEl.innerHTML = '<table>' + rows + '</table>';
  }

  function showError(msg) {
    var el = document.getElementById('ppb-preview-render');
    if (el) el.innerHTML = '<p style="color:#c00;">' + msg + '</p>';
  }

  var params = new URLSearchParams(window.location.search);
  var d = params.get('d');
  if (!d) { showError('Geen ontwerp gevonden in de URL.'); return; }

  try {
    render(decodePreviewParam(d));
  } catch (e) {
    showError('Het ontwerp kon niet worden geladen.');
  }
})();
